package com.wintermar.inspection.core.ui.util

/**
 * Transforms a SCREAMING_SNAKE_CASE string to Title Case format.
 *
 * Examples:
 * - "IN_PROGRESS" → "In Progress"
 * - "UNKNOWN__" → "Unknown"
 * - "APPROVED" → "Approved"
 * - "MY_LONG_STATUS_NAME" → "My Long Status Name"
 *
 * @return The formatted string in Title Case, or the original string if it's empty
 */
fun String.toTitleCase(): String {
    return this
        .lowercase()
        .replace("_", " ")
        .trim()
        .split(" ")
        .filter { it.isNotEmpty() }
        .joinToString(" ") { word ->
            word.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
        }
}

/**
 * Transforms an enum name (SCREAMING_SNAKE_CASE) to a human-readable Title Case format.
 * This is particularly useful for displaying enum values in the UI.
 *
 * Examples:
 * - InspectionStatus.IN_PROGRESS.name.toEnumLabel() → "In Progress"
 * - InspectionStatus.UNKNOWN__.name.toEnumLabel() → "Unknown"
 *
 * @return The formatted enum label in Title Case
 */
fun <E : Enum<E>> E.toEnumLabel(): String = this.name.toTitleCase()

